export const styles = {
  wrapper: {
    '& .SearchAndFilters': {
      paddingLeft: '40px',
    },
    '& table': {
      marginLeft: '-25px',
    },
    '& .Pagination': {
      marginLeft: '40px',
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
  },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/Components/ActivityTable/style.js